import React from 'react';
import { SvgIcon } from '@mui/material';

const SvgBulbOnScreen = (props) => (
  <SvgIcon {...props} title="Bulb on screen" viewBox="1 1 21 21">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      zoomAndPan="magnify"
      viewBox="0 0 135 135.000003"
      height="24"
      preserveAspectRatio="xMidYMid meet"
      version="1.0"
      {...props}
    >
      <defs>
        <clipPath id="967b552a5f">
          <path
            d="M 0.496094 0 L 134.503906 0 L 134.503906 134.007812 L 0.496094 134.007812 Z M 0.496094 0 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="3bdf8510a5">
          <path
            d="M 17.632812 17.136719 L 117.394531 17.136719 L 117.394531 116.898438 L 17.632812 116.898438 Z M 17.632812 17.136719 "
            clipRule="nonzero"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#967b552a5f)"></g>
      <g clipPath="url(#3bdf8510a5)">
        <path
          fill="#017163"
          d="M 109.046875 93.59375 L 25.941406 93.59375 C 23.191406 93.59375 20.957031 91.359375 20.957031 88.605469 L 20.957031 83.621094 L 114.035156 83.621094 L 114.035156 88.605469 C 114.035156 91.359375 111.800781 93.59375 109.046875 93.59375 Z M 78.910156 106.890625 L 56.082031 106.890625 L 57.328125 96.917969 L 77.664062 96.917969 Z M 87.441406 111.875 C 87.441406 112.792969 86.695312 113.539062 85.777344 113.539062 L 49.210938 113.539062 C 48.296875 113.539062 47.550781 112.792969 47.550781 111.875 C 47.550781 110.960938 48.296875 110.214844 49.210938 110.214844 L 85.777344 110.214844 C 86.695312 110.214844 87.441406 110.960938 87.441406 111.875 Z M 114.035156 33.757812 L 114.035156 80.296875 L 20.957031 80.296875 L 20.957031 33.757812 Z M 25.941406 20.460938 L 109.046875 20.460938 C 111.800781 20.460938 114.035156 22.695312 114.035156 25.445312 L 114.035156 30.433594 L 20.957031 30.433594 L 20.957031 25.445312 C 20.957031 22.695312 23.191406 20.460938 25.941406 20.460938 Z M 109.046875 17.136719 L 25.941406 17.136719 C 21.359375 17.136719 17.632812 20.863281 17.632812 25.445312 L 17.632812 88.605469 C 17.632812 93.191406 21.359375 96.917969 25.941406 96.917969 L 53.976562 96.917969 L 52.730469 106.890625 L 49.210938 106.890625 C 46.460938 106.890625 44.226562 109.125 44.226562 111.875 C 44.226562 114.628906 46.460938 116.863281 49.210938 116.863281 L 85.777344 116.863281 C 88.53125 116.863281 90.765625 114.628906 90.765625 111.875 C 90.765625 109.125 88.53125 106.890625 85.777344 106.890625 L 82.261719 106.890625 L 81.011719 96.917969 L 109.046875 96.917969 C 113.632812 96.917969 117.359375 93.191406 117.359375 88.605469 L 117.359375 25.445312 C 117.359375 20.863281 113.632812 17.136719 109.046875 17.136719 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <path
        fill="#017163"
        d="M 104.0625 90.269531 L 107.386719 90.269531 L 107.386719 86.945312 L 104.0625 86.945312 L 104.0625 90.269531 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#017163"
        d="M 30.929688 23.785156 L 27.605469 23.785156 L 27.605469 27.109375 L 30.929688 27.109375 L 30.929688 23.785156 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#017163"
        d="M 37.578125 23.785156 L 34.253906 23.785156 L 34.253906 27.109375 L 37.578125 27.109375 L 37.578125 23.785156 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#017163"
        d="M 44.226562 23.785156 L 40.902344 23.785156 L 40.902344 27.109375 L 44.226562 27.109375 L 44.226562 23.785156 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#017163"
        d="M 59.289062 54.019531 C 59.847656 50.441406 62.871094 47.535156 66.484375 47.113281 C 66.828125 47.074219 67.164062 47.054688 67.507812 47.054688 C 69.546875 47.054688 71.476562 47.78125 73.015625 49.152344 C 74.792969 50.730469 75.804688 52.996094 75.804688 55.363281 C 75.804688 57.617188 74.917969 59.726562 73.300781 61.300781 C 71.773438 62.792969 70.898438 64.855469 70.839844 67 L 69.15625 67 L 69.15625 60.046875 C 71.085938 59.359375 72.480469 57.527344 72.480469 55.363281 L 69.15625 55.363281 C 69.15625 56.28125 68.410156 57.027344 67.496094 57.027344 C 66.582031 57.027344 65.832031 56.28125 65.832031 55.363281 L 62.507812 55.363281 C 62.507812 57.527344 63.90625 59.359375 65.832031 60.046875 L 65.832031 67 L 64.144531 67 C 64.09375 64.871094 63.203125 62.824219 61.601562 61.214844 C 59.71875 59.320312 58.875 56.695312 59.289062 54.019531 Z M 70.820312 73.648438 L 64.171875 73.648438 L 64.171875 70.324219 L 70.820312 70.324219 Z M 60.820312 67 L 57.523438 67 L 57.523438 70.324219 L 60.847656 70.324219 L 60.847656 73.648438 C 60.847656 75.480469 62.339844 76.972656 64.171875 76.972656 L 70.820312 76.972656 C 72.652344 76.972656 74.144531 75.480469 74.144531 73.648438 L 74.144531 70.324219 L 77.46875 70.324219 L 77.46875 67 L 74.164062 67 C 74.214844 65.746094 74.726562 64.550781 75.625 63.679688 C 77.882812 61.472656 79.128906 58.519531 79.128906 55.363281 C 79.128906 52.046875 77.707031 48.878906 75.226562 46.671875 C 72.75 44.464844 69.417969 43.425781 66.09375 43.8125 C 61.027344 44.40625 56.78125 48.484375 56.003906 53.515625 C 55.425781 57.242188 56.609375 60.902344 59.242188 63.558594 C 60.21875 64.539062 60.769531 65.753906 60.820312 67 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#017163"
        d="M 69.15625 37.082031 L 65.832031 37.082031 L 65.832031 40.40625 L 69.15625 40.40625 L 69.15625 37.082031 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#017163"
        d="M 61.457031 41.582031 L 59.796875 38.699219 L 56.914062 40.359375 L 58.574219 43.242188 L 61.457031 41.582031 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#017163"
        d="M 55.375 46.445312 L 52.492188 44.78125 L 50.828125 47.664062 L 53.710938 49.328125 L 55.375 46.445312 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#017163"
        d="M 52.535156 57.027344 L 52.535156 53.703125 L 49.210938 53.703125 L 49.210938 57.027344 L 52.535156 57.027344 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#017163"
        d="M 50.828125 63.066406 L 52.492188 65.949219 L 55.375 64.285156 L 53.710938 61.402344 L 50.828125 63.066406 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#017163"
        d="M 84.160156 63.066406 L 81.28125 61.402344 L 79.617188 64.285156 L 82.5 65.949219 L 84.160156 63.066406 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#017163"
        d="M 82.453125 57.027344 L 85.777344 57.027344 L 85.777344 53.703125 L 82.453125 53.703125 L 82.453125 57.027344 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#017163"
        d="M 84.160156 47.664062 L 82.5 44.78125 L 79.617188 46.445312 L 81.28125 49.328125 L 84.160156 47.664062 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#017163"
        d="M 78.078125 40.359375 L 75.195312 38.699219 L 73.535156 41.582031 L 76.417969 43.242188 L 78.078125 40.359375 "
        fillOpacity="1"
        fillRule="nonzero"
      />
    </svg>
  </SvgIcon>
);

export default SvgBulbOnScreen;
